import React from "react";
import Otp from "./Otp";

const InputOTP = (props) => {
  const {
    id,
    label,
    value,
    onChangeHandler,
    formatId,
    resendOtp,
    resendOtpTime,
  } = props;

  return (
    <div className="authentication__otp" id={formatId(label)}>
      <Otp
        onChange={(e) => onChangeHandler(e, id)}
        otpVal={value}
        otpLength={6}
        errorMessage=""
        boxWidth={50}
        resendOtp={resendOtp}
        resendOtpTime={resendOtpTime}
      />
    </div>
  );
};

export default InputOTP;
